import React from 'react';

interface TabContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function TabContainer({ children, className = '' }: TabContainerProps) {
  return (
    <div className={`fixed inset-0 bg-background/95 backdrop-blur-xl z-[100] overflow-y-auto ${className}`}>
      <div className="min-h-screen p-6">
        <div className="max-w-4xl mx-auto space-y-8">
          {children}
        </div>
      </div>
    </div>
  );
}